import React from 'react';
import Items from './Items';

const Home = () => {
    return (
        <div className='container mt-4'>
            <Items />
        </div>
    )
}

export default Home;
